var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 3.16667C3.33333 2.45942 3.61428 1.78115 4.11438 1.28105C4.61448 0.780951 5.29276 0.5 6 0.5C6.70724 0.5 7.38552 0.780951 7.88562 1.28105C8.38572 1.78115 8.66667 2.45942 8.66667 3.16667C8.66667 3.87391 8.38572 4.55219 7.88562 5.05229C7.38552 5.55238 6.70724 5.83333 6 5.83333C5.29276 5.83333 4.61448 5.55238 4.11438 5.05229C3.61428 4.55219 3.33333 3.87391 3.33333 3.16667ZM3.33333 7.16667C2.44928 7.16667 1.60143 7.51786 0.976311 8.14298C0.351189 8.7681 0 9.61594 0 10.5C0 11.0304 0.210714 11.5391 0.585787 11.9142C0.960859 12.2893 1.46957 12.5 2 12.5H10C10.5304 12.5 11.0391 12.2893 11.4142 11.9142C11.7893 11.5391 12 11.0304 12 10.5C12 9.61594 11.6488 8.7681 11.0237 8.14298C10.3986 7.51786 9.55072 7.16667 8.66667 7.16667H3.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.368797d1418b6dce22a254186a2044f6.svg";
export { ForwardRef as ReactComponent };